
<template>
	<component :is="noCard ? 'div' : 'widget'">
		<div v-if="cert && cert.archived == 1" class="alert alert-warning" style="margin: -8px;margin-top:-18px;border-radius: 0;margin-bottom: 10px;">
			<i class="fa fa-archive"></i>
			This certificate is archived
		</div>
		<template v-if="cert && (!collapsed || uncollapsible)">

			<div class="row" style="margin-left: 0;margin-right: 0;margin-top: 10px;">
				<div class="col-md-6 col-xl-4">
					<image-panel
						v-if="!frontIsPdf"
						:readonly="true"
						class="mb-3 image-panel"
						:image-url="frontImageThumbUrl"
						:expand-url="frontImageUrl"
						icon="fa-certificate"
						:expand-on-click="true">
					</image-panel>

					<iframe v-else
						width="100%"
						height="300"
						:src="frontImageUrl">
					</iframe>

					<image-panel
						v-if="backImageUrl && !backIsPdf"
						:readonly="true"
						class="mb-3 image-panel"
						:image-url="backImageThumbUrl"
						:expand-url="backImageUrl"
						icon="fa-certificate"
						:expand-on-click="true">
					</image-panel>

					<iframe v-else-if="backImageUrl"
						width="100%"
						height="300"
						:src="backImageUrl">
					</iframe>
				</div>

				<div class="col-md-6 col-xl-8">
					<div class="d-flex flex-row justify-content-between">
						<h3 class="cert-title">{{cert.cert_name}}</h3>
						<i v-if="!uncollapsible"
						   class="fa fa-chevron-up icon-button" v-on:click="collapsed = true"></i>
					</div>

					<p v-if="cert.never_expires == 0">Expires in <span :class="{'text-danger': expiryDays < 90}">{{expiryDays}} days</span></p>

					<table class="table table-sm">
						<tbody>
							<tr>
								<th>Certificate Holder</th>
								<td>{{ holderName }}</td>
							</tr>
							<tr>
								<th>Certificate Number</th>
								<td>{{ cert.cert_number }}</td>
							</tr>
							<tr>
								<th>Issue Date</th>
								<td>{{ formatDate(cert.issue_date) }}</td>
							</tr>
							<tr>
								<th>Expiry Date</th>
								<td v-if="cert.never_expires == 0">{{ formatDate(cert.expiry_date) }}</td>
								<td v-else>Never</td>
							</tr>
							<tr>
								<th>Issuing Organization</th>
								<td>{{cert.issuing_org}}</td>
							</tr>
							<tr>
								<th>Instructor/Issuer Name</th>
								<td>{{cert.instructor_name}}</td>
							</tr>
							<tr>
								<th>Training Location</th>
								<td>{{ cert.training_location }}</td>
							</tr>

						</tbody>
					</table>

					<div v-if="!readonly" class="d-flex flex-row justify-content-between align-items-start">

						<button v-if="$store.userDetails.slug == $route.params.id" class="btn btn-outline-danger btn-sm" v-on:click="deleteCert">
							<i class="fa fa-trash"></i>
							Delete
						</button>

						<div>
							<button class="btn btn-light btn-sm" v-on:click="toggleArchive(cert.archived == 0)">
								<i class="fa fa-archive"></i>
								{{cert.archived == 1 ? 'Un-archive' : 'Archive'}}
							</button>
							<button class="btn btn-light btn-sm" v-on:click="editCert">
								<i class="fa fa-edit"></i>
								Edit
							</button>
						</div>
					</div>
				</div>
			</div>

			<form v-if="!readonly" style="margin:10px;" v-on:submit.prevent="applyToCompanyCert">

				<div class="d-flex flex-row align-items-center">
					<field label="Apply to Employer Certificate"
						   style="flex-grow: 1"
						   col-class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
						   v-model="employerCertId"
						   :params="{type:'select',options:companyCertOptions}">
					</field>
					<div class="apply-controls">
						<button class="btn btn-success" style="margin-bottom: 0.4rem;margin-left: 5px;">
							Apply
						</button>
						<button type="button" v-on:click="clearCertConnection" class="btn btn-light" style="margin-bottom: 0.4rem;margin-left: 5px;">
							<i class="fa fa-times"></i>
							Clear
						</button>
					</div>
				</div>

				<alert
					v-if="(getUserRoleType() == 'Admin' || hasModulePermWrite('Certificates')) && (cert.UserCompanyCertificate.length > 0 && cert.UserCompanyCertificate[0].user_cert_accepted == 0)"
					:visible="true"
					:unclosable="true"
					message="This certificate has been applied by the employee. Would you like to approve this association?"
					classes="alert-info"
					button-class="btn-primary"
					button-text="Approve"
					button-icon="fa-check"
					v-on:buttonClick="approveAttachedCert">
				</alert>
				<alert
					v-else-if="cert.UserCompanyCertificate.length > 0 && cert.UserCompanyCertificate[0].user_cert_accepted == 0"
					:visible="true"
					:unclosable="true"
					message="The application to the Employer certificate is awaiting approval"
					classes="alert-info">
				</alert>
			</form>
		</template>
		<div v-else style="padding: 5px;" v-on:click="collapsed = false">
			<div class="d-flex flex-row flex-start" >
				<div class="mr-4">
					<image-panel
						style="max-width: 100px;max-height: 100px;display: inline-block;"
						:readonly="true"
						class="mb-3 image-panel"
						:image-url="frontImageThumbUrl"
						:expand-url="frontImageUrl"
						:icon="frontIsPdf ? 'fa-file-pdf' : 'fa-certificate'"
						:expand-on-click="true">
					</image-panel>
					<image-panel
						v-if="backImageUrl"
						style="max-width: 100px;max-height: 100px;display: inline-block;"
						:readonly="true"
						class="mb-3 image-panel"
						:image-url="backImageThumbUrl"
						:expand-url="backImageUrl"
						:icon="backIsPdf ? 'fa-file-pdf' : 'fa-certificate'"
						:expand-on-click="true">
					</image-panel>
				</div>
				<div class="mr-4">
					<h3 class="cert-title">{{cert.cert_name}}</h3>
					<div v-if="cert.never_expires == 0">
						Expires in
						<span :class="{'text-danger': expiryDays < 90}">
						{{expiryDays}} days
						</span>
					</div>
				</div>
				<i v-if="!uncollapsible" class="ml-auto fa fa-chevron-down icon-button" v-on:click="collapsed = false"></i>
			</div>

		</div>

	</component>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import Alert from "@/components/Alert"
import ImagePanel from "@/components/ImagePanel"
import Field from "@/components/Field"

export default {
	name: "CertificateCard",
	components: {
		Widget,
		Alert,
		ImagePanel,
		Field
	},
	props: ["cert","companyCerts","uncollapsible","noCard","readonly"],
	data() {
		return {
			collapsed: true,
			employerCertId: 0
		}
	},
	watch: {
		cert() {
			this.setEmployerCertId()
		}
	},
	computed: {
		companyCertOptions() {
			return this.optionify(this.companyCerts,"cert_name")
		},
		frontImageUrl() {
			if (this.cert.FrontImage && "filename" in this.cert.FrontImage)
				return window.apiRoot+"resources/images/"+this.$store.sessionToken+"/"+this.cert.FrontImage.filename
			else
				return false


		},
		frontImageThumbUrl() {
			if (this.cert.FrontImage && "thumb_filename" in this.cert.FrontImage && this.cert.FrontImage.thumb_filename != "")
				return window.apiRoot+"resources/images/"+this.$store.sessionToken+"/"+this.cert.FrontImage.thumb_filename
			else
				return false

		},
		backImageUrl() {
			if (this.cert.BackImage && "filename" in this.cert.BackImage)
				return window.apiRoot+"resources/images/"+this.$store.sessionToken+"/"+this.cert.BackImage.filename
			else
				return false
		},
		backImageThumbUrl() {
			if (this.cert.BackImage && "thumb_filename" in this.cert.BackImage && this.cert.BackImage.thumb_filename != "")
				return window.apiRoot+"resources/images/"+this.$store.sessionToken+"/"+this.cert.BackImage.thumb_filename
			else
				return false
		},
		holderName() {
			return this.cert.holderName = this.cert.User.first_name +" "+this.cert.User.last_name
		},
		backIsPdf() {
			if (this.cert.BackImage) {
				let ext = this.cert.BackImage.filename.split(".").pop()

				if (ext == "pdf")
					return true
			}
			else return false
		},
		frontIsPdf() {
			if (this.cert.FrontImage) {
				let ext = this.cert.FrontImage.filename.split(".").pop()

				if (ext == "pdf")
					return true
			}
			else return false
		},
		expiryDays() {
			return this.moment(this.cert.expiry_date).diff(this.moment(),'days')
		}
	},
	methods: {
		setEmployerCertId() {
			let vm = this

			if (this.cert.UserCompanyCertificate.length > 0 && this.cert.UserCompanyCertificate[0]) //make sure companyCerts list is populated before trying to apply binding
				this.employerCertId = this.cert.UserCompanyCertificate[0].tenant_cert_id
			else
				this.employerCertId = 0
		},
		deleteCert() {
			this.$emit("deleteCert",this.cert)
		},
		editCert() {
			this.$emit("editCert",this.cert)
		},
		applyToCompanyCert() {
			let vm = this

			vm.$emit("applyToCompanyCert",{
				employerCertId: vm.employerCertId,
				id: vm.cert.id
			})
		},
		clearCertConnection() {
			this.$emit("clearCertConnection",this.cert)
		},
		approveAttachedCert() {
			let vm = this

			vm.$emit("approveAttachedCert", vm.employerCertId)
			
		},
		toggleArchive(archive) {
			this.$emit("toggleArchive",this.cert,archive)
		}
	},
	created() {
		this.setEmployerCertId()
	}
}
</script>

<style type="text/css" scoped>

@media (max-width: 767px) {
	form .d-flex {
		flex-direction: column!important;
	}
}

</style>